export class Utils {
  public static ColorEnum = {
    positive: 'positive-color',
    negative: 'negative-color',
    neutro: 'neutral-color',
    blue: 'blue-color',
    white: 'white-color',
  };

  public static formatString(text: string, values: any[]): string {
    if (text === '') {
      return 'empty text';
    }
    let i = values.length;
    while (i--) {
      text = text.replace(/\{\{|\}\}|\{(\w+)\}/g, (m, n) => {
        if (m === '{{') {
          return '{';
        }
        if (m === '}}') {
          return '}';
        }
        return values[n];
      });
    }

    return text;
  }

  public static getTechLocale(currencyCode) {
    let locale: string;
    switch (currencyCode) {
      case 'EUR':
        locale = 'es';
        break;
      case 'GBP':
        locale = 'en';
        break;
      case 'NOK':
        locale = 'nl';
        break;
      default:
        locale = 'en';
        break;
    }

    return locale;
  }
}
